import React, { useState } from 'react';
import PropTypes from 'prop-types';
import style from './style.module.css';

export const Toggle = ({ children, onClick, isOn, offAfter }) => {
  const [internalOn, setInternalOn] = useState(isOn);
  const className = (internalOn && offAfter) ? 'on' : 'off';

  if (offAfter && !isOn) {
    setTimeout(() => {
      setInternalOn(isOn);
    }, offAfter);
  } else if (isOn !== internalOn) {
    setInternalOn(isOn);
  }

  return (
    <div role="button" onClick={onClick} className={[style.container, style[className]].join(' ')}>
      {children}
    </div>
  );
};

Toggle.propTypes = {
  children: PropTypes.element,
  onClick: PropTypes.func,
  isOn: PropTypes.bool,
  offAfter: PropTypes.number,
};

export default Toggle;
